import { IBranchForm } from "../../../@types/branch";

export const formVals: IBranchForm = {
  branchId: "",
  brCode: "",
  brand: "",
  state: "",
  manager: "",
  address1: "",
  city: "",
  zip: "",
  phone: "",
  brandSlug: "",
  branchDistrictId: "",
  creditBureauTypeId: "",
  webPage: "",
  longitude: 0,
  latitude: 0,
  timeZone: "",
  hours: "",
  branchStatusId: "",
  maxLoanAmount: "",
  lmsId: "",
  branchDensityTypeId: "",
  branchEmail: "",
  hasAccessToFindABranch: true,
  isActive: true,
  isCentralSales: false,
  branchProducts: [],
  legalAddress: "",
  legalEntitySmallLoan: "",
  legalEntityLargeLoan: "",
  legalProductTypeId: "",
  county: "",
  branchOperatingTypeId: "",
};

const alphanumeric = /^[a-zA-Z0-9\s]*$/;
const phoneValidation = new RegExp(
  /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
);
const URLValidation = new RegExp(
  "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
);

interface IValidationObject {
  branchId: boolean;
  brCode: boolean;
  brand: boolean;
  state: boolean;
  address1: boolean;
  city: boolean;
  zip: boolean;
  brandSlug: boolean;
  branchDistrictId: boolean;
  creditBureauTypeId: boolean;
  timeZone: boolean;
  branchStatusId: boolean;
  maxLoanAmount: boolean;
  lmsId: boolean;
  branchDensityTypeId: boolean;
  branchEmail: boolean;
  branchOperatingType: boolean;
  legalAddress: boolean;
  legalEntitySmallLoan: boolean;
  legalEntityLargeLoan: boolean;
  legalProductTypeId: boolean;
  isCentralSales: boolean;
  county: boolean;
  isActive: boolean;
  phone: boolean;
  hours: boolean;
  webPage: boolean;
  longitude: boolean;
  latitude: boolean;
  mgrEmail: boolean;
  manager: boolean;
  underwritingTypeId: boolean;
  branchOperatingState: boolean;
}

export const validationObject: IValidationObject = {
  branchId: false,
  brCode: false,
  brand: false,
  state: false,
  address1: false,
  city: false,
  zip: false,
  brandSlug: false,
  branchDistrictId: false,
  creditBureauTypeId: false,
  timeZone: false,
  branchStatusId: false,
  maxLoanAmount: false,
  lmsId: false,
  branchDensityTypeId: false,
  branchEmail: false,
  branchOperatingType: false,
  legalAddress: false,
  legalEntityLargeLoan: false,
  legalEntitySmallLoan: false,
  legalProductTypeId: false,
  county: false,
  isActive: false,
  isCentralSales: false,
  phone: false,
  hours: false,
  webPage: false,
  longitude: false,
  latitude: false,
  mgrEmail: false,
  manager: false,
  underwritingTypeId: false,
  branchOperatingState: false,
};

export const requiredValidation = (
  name: string,
  value: any,
  branchStatus?: number | string | undefined,
  legalProductTypeId?: string | number | undefined
): boolean => {
  let invalidValue = false;

  switch (name) {
    case "brCode":
    case "brand":
    case "brandSlug":
    case "creditBureauTypeId":
    case "lmsId":
    case "isActive":
    case "address1":
    case "city":
    case "branchOperatingState":
    case "state":
    case "branchDistrictId":
    case "branchDensityTypeId":
    case "timeZone":
    case "branchStatusId":
    case "maxLoanAmount":
    case "timezone":
    case "underwritingTypeId":
      invalidValue = value === 0 || value === "";
      break;
    case "branchId":
      invalidValue = !(value && value.toString().length === 4);
      break;

    case "zip":
      invalidValue = !(value && value.toString().length === 5);
      break;

    default:
      break;
  }
  if (legalProductTypeId === 1 || legalProductTypeId === 3) {
    if (name === "legalEntitySmallLoan") {
      invalidValue = !(
        value !== null &&
        value !== undefined &&
        value !== "" &&
        value.toString().length <= 255
      );
    }
  }

  if (legalProductTypeId === 2 || legalProductTypeId === 3) {
    if (name === "legalEntityLargeLoan") {
      invalidValue = !(
        value !== null &&
        value !== undefined &&
        value !== "" &&
        value.toString().length <= 255
      );
    }
  }

  if (branchStatus === 0) {
    switch (name) {
      case "hours":
      case "manager":
      case "branchEmail":
      case "mgrEmail":
        invalidValue = Boolean(value === "" || value === 0);
        break;

      case "phone":
        invalidValue = !(value && phoneValidation.test(value.toString()));

        break;

      case "webPage":
        invalidValue = !(value && URLValidation.test(value.toString()));
        break;

      case "longitude":
        invalidValue = !(value && Number(value) <= 180);
        break;

      case "latitude":
        invalidValue = !(value && Number(value) <= 90);
        break;
    }
  }
  return invalidValue;
};

export const optionalValidation = (name: string, value: any): boolean => {
  let invalidValue = false;

  switch (name) {
    case "legalAddress":
      if (value && value !== "") {
        invalidValue = !(
          value.toString().length <= 255 && alphanumeric.test(value.toString())
        );
      }
      break;
    case "legalEntity":
    case "county":
      if (value !== null && value !== undefined && value !== "") {
        invalidValue = !(
          value.toString().length <= (name === "legalEntity" ? 255 : 100) &&
          alphanumeric.test(value.toString())
        );
      } else {
        invalidValue = true;
      }
      break;

    default:
      break;
  }

  return invalidValue;
};
